import { useState } from "react";
import { deepCopy, updateNestedValue } from "../../../../../../common/services/common.service";
import Popup from "../../../../../../common/components/popup";
import SettlementRequestsBasicInfoComponent from "./settlement-requests-basic-info.component";

export const SettlementRequestPopup = ({ 
  selectedSettlementRequest,
  closeModal,
  handleSaveSettlementRequest,
}: any) => {
    const [localAttribute, setLocalAttribute] = useState(deepCopy(selectedSettlementRequest));

    const handleLocalFormChange = ({path, value}: any) => {
      // setLocalAttribute(prev => ({
      //   ...prev,
      //   [field]: value,
      // }));
      console.log('selectedSettlementRequest, path, value', selectedSettlementRequest, path, value)
      const updatedData = updateNestedValue(selectedSettlementRequest, path, value)
  
      console.log('updatedData', updatedData)
      setLocalAttribute({...updatedData});
    };

    const handleFormSubmit = () => {
      handleSaveSettlementRequest(localAttribute)
    };

    return (
      <>
        <Popup onClose={closeModal}>
          <SettlementRequestsBasicInfoComponent
            onClose={closeModal}
            handleInnerFormChange={handleLocalFormChange}
            selectedSettlementRequest={selectedSettlementRequest}
            handleFormSubmit={handleFormSubmit}
          />
        </Popup>
      </>
    )
  }